// extracted by mini-css-extract-plugin
export default {"option":"customStyles_option__raDTJ"};